'use client';

import { useEffect, useState } from 'react';
import { checkUserPlan, type UserPlan } from '@/lib/neo/checkUserPlan';

export function useCheckUserPlan(userId?: string) {
  const [planData, setPlanData] = useState<UserPlan | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) return;
    setLoading(true);
    checkUserPlan(userId)
      .then(setPlanData)
      .finally(() => setLoading(false));
  }, [userId]);

  return { planData, loading };
}
